export default function Contact() {
    return (
        <div>
            <div className="card">
  <div className="card-body">
    <h5 className="card-title">Addresses: </h5>
    <h6 className="card-subtitle mb-2 text-muted">10/53, Tompson Suites, NSW 2650</h6>
    <h6 className="card-subtitle mb-2 text-muted">55, Foyle Road Bayswater, WA 6053</h6>
        <br/>
    <h5 className="card-title">Contact Numbers: </h5>
    <a href="/#" className="card-link">0455032407</a>
    <a href="/#" className="card-link">0468327418</a>
       <br/> 
        <br/>
    <h5 className="card-title">Email: </h5>
    <h6 className="card-subtitle mb-2 text-muted">amanm@jtax.com.au</h6>
    <h6 className="card-subtitle mb-2 text-muted">arnican08@gmail.com</h6>
        <br/>
    <h5 className="card-title">Timings: </h5>
    <h6 className="card-subtitle mb-2 text-muted">Monday to Friday</h6>
    <h6 className="card-subtitle mb-2 text-muted">10:00 AM to 5:00 PM</h6>
  </div>
</div>
        </div>
    )
}
